'use client'

import React, { FC, PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'
import ButtonAction from '@/components/button-action'
import styles from './ActionDrawer.module.css'

const ActionDrawer: FC<
	PropsWithChildren<{
		open: boolean
		handleDrawerToggle: (evt?: any) => void
		icon?: FC<{ className?: string }>
		title: string
		className?: string
		drawerClassName?: string
		buttonColor?: 'gray' | 'black'
	}>
> = (props): ReactElement => {
	const { open, icon, title, handleDrawerToggle, drawerClassName } = props

	const handleClick = React.useCallback(
		(evt: any) => {
			handleDrawerToggle && handleDrawerToggle(evt)
		},
		[handleDrawerToggle]
	)

	return (
		<div className={styles.root}>
			<ButtonAction
				className={props.className}
				open={open}
				icon={icon}
				title={title}
				handleClick={handleClick}
				background={props?.buttonColor}
			/>
			<div
				className={classNames({ [(props.drawerClassName as any)]: !!drawerClassName }, styles.drawer, {
					[styles.openDrawer]: open
				})}
			>
				{props.children}
			</div>
		</div>
	)
}

export default ActionDrawer
